/**
 * Unser offener Benchmark für lokale KI auf AMD-Hardware – eine eigene Seite
 * mit eigenem Repo (benchmark.securesight.ai). Verlinkt aus Menü, Footer und
 * dem Abschnitt "Gaming-PC schlägt Rechenzentrum".
 */
export const BENCHMARK_URL = 'https://benchmark.securesight.ai'

/**
 * Die Benchmark-Seite gibt es auf Deutsch und Englisch. Deutsch führt auf die
 * deutsche Fassung, alle anderen Sprachen der Homepage (en, es, fr, hi) auf
 * die englische.
 */
export function benchmarkUrl(lang: string | undefined): string {
  return lang?.toLowerCase().startsWith('de') ? `${BENCHMARK_URL}/` : `${BENCHMARK_URL}/en`
}
